import { render, staticRenderFns } from "./FolderListItem.vue?vue&type=template&id=48971cff"
import script from "./FolderListItem.vue?vue&type=script&lang=js"
export * from "./FolderListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports